export const emptyObject = {}
